
import { DashboardLayout } from "@/components/layouts/DashboardLayout";
import { WorkforceOverview } from "@/features/workforce/components/WorkforceOverview";

export default function WorkforcePlanning() {
  return (
    <DashboardLayout>
      <WorkforceOverview />
    </DashboardLayout>
  );
}
